
import {Injectable} from '@angular/core';
import {Http, Response} from '@angular/http';
import {DocumentNews} from '../model/document-news.model';
import {BaseService} from './base.service';
import {AuthService} from '../auth/auth.service';
import {Observable} from 'rxjs';

@Injectable()
export class DocumentNewsService extends BaseService<DocumentNews> {

  constructor(_authService: AuthService,
              _http: Http) {
    super('/api/news', _authService, _http);
  }

  findTop(): Observable<DocumentNews[]> {
    return this._http.get(this._baseUrl + '/top', {headers: this._authService.getAuthorizationHeaders()})
      .map((res: Response) => res.json())
      ;
  }

  getYears(): Observable<number[]> {
    return this._http.get(this._baseUrl + '/year', {headers: this._authService.getAuthorizationHeaders()})
      .map((res: Response) => res.json())
      ;
  }

  findByYear(year: number): Observable<DocumentNews[]> {
    return this._http.get(this._baseUrl + '/year/' + year, {headers: this._authService.getAuthorizationHeaders()})
      .map((res: Response) => res.json())
      ;
  }
   findBySearchString(searchStr: String): Observable<DocumentNews[]> {
    return this._http.get(this._baseUrl + '/search/' + searchStr, {headers: this._authService.getAuthorizationHeaders()})
      .map((res: Response) => res.json())
      ;
  }

  getNewsModules(newsid: number): Observable<DocumentNews[]> {
    return this._http.get(this._baseUrl + '/modules/' + newsid, {headers: this._authService.getAuthorizationHeaders()})
      .map((res: Response) => res.json())
      ;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/service/document-news.service.ts